import LoggerService,{formatTrace,formatInfo} from '../../LoggerService';
import {_checkTokens,_checkErrors,_tryOrRefresh,I_COMMON_GET_ALL_PARAMS,I_COMMON_DELETE_PARAMS,I_COMMON_GET_ITEM_PARAMS} from './_base';

import I_USERS,{I_USER} from '../interfaces/I_USERS';
import {
  getUsersResponse,
  postUserResponse,
  deleteUserResponse,
  putUserResponse,
  getUserResponse,
} from '../ApiEndpoints';

// ---------------------------------
// --- USERS
// ---------------------------------

const logger = LoggerService.getInstance();

/**
 * Récupère la liste des utilisateurs
 * @param obj
 * @returns
 */
const getList = async ({accessToken,refreshToken,page,dispatch,state}:I_COMMON_GET_ALL_PARAMS):Promise<I_USERS> => {
  logger.debug('ApiServices - getUsers - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getUsersResponse({accessToken:usedAccessToken,page});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getUsers - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_USERS = await response.json();
  logger.debug('ApiServices - getUsers - ok, returned body',body);
  return body;
};


interface I_CREATE_USER_PARAMS {
  accessToken?: string,
  refreshToken?: string,
  lastname: string,
  firstname: string,
  email: string,
  id_osac: string,
  roles: string,
  sso: boolean,
  password: string,
  dispatch: any; // on a besoin du dispatch pour store les tokens en cas de refresh
  state: any; // on a besoin du state pour comparer les tokens en cas de 401
}
/**
 * Crée une compétence
 * @param param0
 * @returns
 */
const create = async ({accessToken,refreshToken,lastname,firstname,email,id_osac,roles,sso,password,dispatch,state}:I_CREATE_USER_PARAMS):Promise<string> => {
  logger.debug('ApiServices - createUser - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (
    !lastname || lastname === null || lastname.trim() === '' ||
    !firstname || firstname === null || firstname.trim() === '' ||
    email === undefined || email === null || email.trim() === '' ||
    roles === undefined || roles === null || roles.trim() === '') {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing lastname, firstname, email, or role',
      errorMessage: 'Missing lastname, firstname, email, or role to post user',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return postUserResponse({accessToken:usedAccessToken,lastname,firstname,email,id_osac,roles,sso,password});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - createUser - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - createUser - ok, returned body',body);
  logger.info(...formatInfo('User created!'));
  return body;
};

/**
 * Supprime un collaborateur
 * @param param0
 * @returns
 */
const remove = async ({accessToken,refreshToken,id,dispatch,state}:I_COMMON_DELETE_PARAMS):Promise<string> => {
  logger.debug('ApiServices - deleteUser - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return deleteUserResponse({accessToken:usedAccessToken,id});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - deleteUser - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - deleteUser - ok, returned body',body);
  logger.info(...formatInfo('User deleted!'));
  return body;
};


interface I_PUT_TASK_TYPE_PARAMS {
  accessToken?: string,
  refreshToken?: string,
  id: number,
  lastname: string,
  firstname: string,
  email: string,
  sso: boolean,
  id_osac: string,
  roles: string,
  dispatch: any; // on a besoin du dispatch pour store les tokens en cas de refresh
  state: any; // on a besoin du state pour comparer les tokens en cas de 401
}
/**
 * Modifie un type de tache
 * @param param0
 * @returns
 */
const update = async ({accessToken,refreshToken,id,email,id_osac,firstname,lastname,sso,roles,dispatch,state}:I_PUT_TASK_TYPE_PARAMS):Promise<string> => {
  logger.debug('ApiServices - updateUser - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (
    !lastname || lastname === null || lastname.trim() === '' ||
    !firstname || firstname === null || firstname.trim() === '' ||
    email === undefined || email === null || email.trim() === '') {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing lastname, firstname or email',
      errorMessage: 'Missing lastname, firstname or email to post user',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return putUserResponse({accessToken:usedAccessToken,id,email,sso,id_osac,firstname,lastname,roles});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - updateUser - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - updateUser - ok, returned body',body);
  logger.info(...formatInfo('User updated!'));
  return body;
};


/**
 * Récupère l'utilisateur
 * @param param0
 * @returns
 */
const getItem = async ({accessToken,refreshToken,id,dispatch,state}:I_COMMON_GET_ITEM_PARAMS) => {
  logger.debug('ApiServices - getUser - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getUserResponse({accessToken:usedAccessToken,id});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getUser - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_USER = await response.json();
  logger.debug('ApiServices - getUser - ok, returned body',body);
  return body;
};


const usersServices = {
  getList,
  create,
  remove,
  update,
  getItem,
};

export default usersServices;
